<template>
  <div>
    <div class="hero">
      <img src="/static/img/discover-hero.jpg">
      <div class="wrap">
        <div class="content">
          <h1>Discover</h1>
          <p class="sub">
            Find the best content, filtered and chosen <br> the way you want.
          </p>
          <p>
            <b-form-input type="text"
                          v-model="q"
                          placeholder="Search by artist, lyrics, title, genre, mood, or instrument"
                          @keyup.native="onKeyUp" />
          </p>
          <p>
            <b-button class="btn-rainbow" @click="search">
              <font-awesome-icon icon="search" /> &nbsp; search
            </b-button>
          </p>
        </div>
      </div>
    </div>

    <b-container class="section-container">
      <DiscoverTabs :results="$route.meta.action === 'results'"></DiscoverTabs>
    </b-container>

    <b-container class="section-container">
      <b-row class="py-4" v-if="query">
        <b-col>
          <h4>Your search results</h4>
        </b-col>
      </b-row>

      <DiscoverResults :query="query" v-if="query" :action="$route.meta.action" />
      <DiscoverResults :recommended="true" v-else :action="$route.meta.action" />
    </b-container>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .hero {
    margin: 0px -15px 1em -15px;
    position: relative;
    overflow: hidden;
    &:before {
      content: 'Discover';
      position: absolute;
      width: 100%;
      text-align: center;
      opacity: 0.17;
      top: -140px;
      margin-left: 8%;
      font-size: 15em;
      font-family: 'AvenirHeavy';
    }

    img {
      width: 100%;
      object-fit: cover;
      opacity: 0.7;
    }

    .wrap {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 2;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 50%, $body-bg);

      .content {
        text-align: center;

        h1 {
          font-size: 4em;
          margin: 0;
          margin-bottom: .5rem;
          @include media-breakpoint-down(md) {
            font-size: 2.5em;
          }
        }

        .sub {
          margin-bottom: 2em;
          @include media-breakpoint-down(md) {
            font-size: .9em;
          }
        }

        input {
          width: 80%;
          border-radius: 24px;
          display: inline-block;
          text-align: center;
        }

        button {
          padding-left: 2em;
          padding-right: 2em;
        }
      }
    }
    @include media-breakpoint-down(md) {
      height: 300px;
      &:before {
        font-size: 8em;
        top: -80px;
      }
      img {
        height: 300px;
      }
    }
  }
  .section-container {
    @include media-breakpoint-down(sm) {
      padding: 0;
      .container {
        padding: 0;
      }
    }
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import DiscoverTabs from '@/components/widgets/DiscoverTabs'
import DiscoverResults from '@/components/widgets/DiscoverResults'

export default {
  name: 'Discover',
  components: {
    FontAwesomeIcon,
    DiscoverTabs,
    DiscoverResults
  },
  data () {
    return {
      artists: null,
      albums: null,
      videos: null,
      playlists: null,
      q: '',
      query: null
    }
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    initPage () {
      this.q = this.$route.query.q || ''
      if (this.q) {
        this.search()
      } else {
        this.query = null

        // if no query, go to recommended results instead
        if (this.$route.meta.action === 'results') {
          this.$router.push({name: 'discover'})
        }
      }
    },
    onKeyUp (ev) {
      if (ev.key !== 'Enter') return
      this.search()
    },
    search () {
      if (this.$route.meta.action === 'results') {
        this.query = this.q
      } else {
        this.$router.push({name: 'discover-results', query: {q: this.q}})
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/discover/Discover.vue